import { type RootBootstrapData } from 'app/root/types'

// Reads the subset serialized by RootBootstrapScript. `keys` come from `window.KEYS`.
export function getRootLoaderData(): RootBootstrapData | undefined {
  return window.__ROOT_BOOTSTRAP__
}
